export const isMainPage = () => /^\/(en|lt)(\/?)$/.test(window.location.pathname)

export function GetLink(to: string, text: string) {
  return (
    <a href={`/${to}`} target="_blank" rel="noreferrer">
      {text}
    </a>
  )
}

export const setCookieConsentBottom = (bottom: number) => {
  setTimeout(() => {
    const cookiContainer = document.querySelector(".CookieConsent") as HTMLDivElement
    if (cookiContainer != null) cookiContainer.style.bottom = `${bottom}px`
  }, 100)
}
export const scrollTo: (idName: string) => void = (idName) =>
  document.getElementById(idName)?.scrollIntoView({ behavior: "smooth" })
